import { DocumentsWidget } from '@/widgets/settings'

export const DocumentsPage = () => {
    return <DocumentsWidget />
}
